import { faEye } from "@fortawesome/free-regular-svg-icons/faEye";
export let iconEye = faEye;
export function overwriteEye(icon) {
    iconEye = icon;
}
export default iconEye;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXllLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2V5ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sMkNBQTJDLENBQUM7QUFFbEUsTUFBTSxDQUFDLElBQUksT0FBTyxHQUFHLEtBQUssQ0FBQztBQUUzQixNQUFNLFVBQVUsWUFBWSxDQUFDLElBQW9CO0lBQy9DLE9BQU8sR0FBRyxJQUFJLENBQUM7QUFDakIsQ0FBQztBQUVELGVBQWUsT0FBTyxDQUFDIn0=